import React from 'react';

const Loader = () => {
    return (
        <div class="wrapper">
            <div class="squre-frame"></div>
            <div class="squre-frame"></div>
            <div class="squre-frame"></div>
        </div>

    );
}
export default Loader;
